jQuery(".js-load-more-posts-news").on("click", function(e) {
    console.log("testing");
    e.preventDefault();
    jQuery(this).prop("disabled", true);
   
    var paged = jQuery(this).attr('data-paged');
    var posts_per_page = parseInt(jQuery(this).attr('data-posts-per-page'));
    var lang = "";
    var data_lang = jQuery(this).attr("data-lang");
    if (typeof data_lang !== typeof undefined && data_lang !== false) {
        lang = data_lang;
    }
    var url = window.location.origin + "/wp-content/themes/franchise/load-latest-posts-newsroom.php";
    if(lang != ""){
        url = window.location.origin + "/es/wp-content/themes/franchise/load-latest-newsroom.php";
    }
   
    $.ajax({
        url: url,
        data: "paged=" + paged + "&posts_per_page=" + posts_per_page,
        type: "GET",
        success: function(data) {
            console.log("Raw data received:", data); // Agrega este mensaje para ver qué se recibe
   
            // Intenta parsear la respuesta como JSON
            var obj;
            try {
                obj = jQuery.parseJSON(data);
            } catch (e) {
                console.error("Error parsing JSON:", e);
                return; // Sale de la función si hay un error
            }
   
            // Continúa con el resto del código para manejar los datos correctamente
            if (obj.content.length > 0) {
                var max_num_paged = parseInt(obj.max_num_pages);
   
                paged = parseInt(paged) + 1;
   
                if (paged > max_num_paged) {
                    jQuery(".js-load-more-posts-news").hide();
                }
                jQuery(".js-load-more-posts-news").attr('data-paged', paged);
               
                // Seleccionar el último elemento de la lista y agregar el nuevo contenido después de él
                jQuery("ul.c-results__list li.o-list-bare__item:last").after(obj.content);
                jQuery(".js-load-more-posts-news").prop("disabled", false);
            }
        }
    });
   
});
function checkNumberOfItems() {
    var itemCount = jQuery("ul.c-results__list li.o-list-bare__item.c-results__item").length;
    if (itemCount < 4) {
        jQuery(".js-load-more-posts-news").hide();
    } else {
        jQuery(".js-load-more-posts-news").show();
    }
}
checkNumberOfItems();